import React from 'react';
import ImageGallerconference from '../components/ImageGallerconference';
import IRCTVDonationCard from "./IRCTVDonationCard";


const IRCconference = () => {
    const charityBaseAmount = 30000;


    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    <ImageGallerconference />

                    {/* IRC 10 Days Conference */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>IRC 10 DAYS CONFERENCE</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                                Since Ramadhaan 2001, IRC has been conducting a 10 Day Annual Educational Conference during the last Ashara (last ten days) of the month of Ramadhaan. This conference is attended by thousands of men and women every year and is the largest gathering of Muslims in the month of Ramadhaan in Chhatrapati Sambhajinagar (Aurangabad).
                            </p>
                            <p>
                                Speakers from IRC grace this event by delivering speeches on various topics, beneficial for Duniya and Aakhirah.
                            </p>
                        </div>
                        <IRCTVDonationCard
                            baseAmount={charityBaseAmount}

                            title="IRC 10 DAYS CONFERENCE"
                            subtitle="Your donation makes a difference"
                            description="Donate Us continue providing quality content and services to our community."
                            amount="₹5000"
                            purpose="Cause: SPONSER A DAY"
                        />
                    </div>
                </section>
            </div>
        </>
    );
};

export default IRCconference;
